<template>
  <div
    class="layout_column layout_column_new one_column"
    :id="'u' + column.widgets_id"
    :data-id="column.widgets_id"
    :data-index="col_index"
    :data-order="column.data.mb_infor.order"
    :style="{
          backgroundColor: background_obj.background_set.radio_val !== 'hidden' ? background_obj.background_set[background_obj.background_set.radio_val].color : '',
          borderColor: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_color : '',
          borderStyle: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_style : '',
          borderLeftWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_left_width + 'px' : '',
          borderRightWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_right_width + 'px' : '',
          borderTopWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_top_width + 'px' : '',
          borderBottomWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_bottom_width + 'px' : '',
          backgroundImage:background_obj.background_set.radio_val !== 'hidden' && background_obj.background_set[background_obj.background_set.radio_val].img !== '' ? 'url('+background_obj.background_set[background_obj.background_set.radio_val].img+')' : 'none',
          boxShadow: infor.is_shadow == 'true' ? 'rgba(0, 0, 0, 0.15) 0px 0px 12px 0px': '0 0 0 #fff',
          backgroundSize: background_obj.background_set.radio_val !== 'hidden' ? background_obj.background_set[background_obj.background_set.radio_val].background_size: 'auto',
          backgroundRepeat: background_obj.background_set.radio_val !== 'hidden' ?background_obj.background_set[background_obj.background_set.radio_val].background_repeat: 'repeat',
          backgroundPosition: background_obj.background_set.radio_val !== 'hidden' ?background_obj.background_set[background_obj.background_set.radio_val].background_position : '0% 0%',
          paddingLeft: padding_obj.padding_left,
          paddingRight: padding_obj.padding_right,
          paddingTop: padding_obj.padding_top,
          paddingBottom: padding_obj.padding_bottom,
          marginLeft: $store.state.app.view_pattern === 'pc' ? infor.margin_left : 0,
          marginRight: $store.state.app.view_pattern === 'pc' ? infor.margin_right : 0,
          marginTop: margin_obj.margin_top,
          marginBottom: margin_obj.margin_bottom,
          order:$store.state.app.view_pattern === 'mb' && col_order_val === 'custom' ? column.data.mb_infor.order : 0,
          ...columnStyle
      }"
    :rowType="column.rowType"
    name="layout_column"
    :pid="column.pid"
    :col="column.data[$store.state.app.view_pattern + '_infor'].col"
    :data-type="has_system_module ? 'has_system_module' : ''"
    :class="[
        col_num,
        has_system_module ? 'has_system_module' : '',
        column.children == 0 ? 'no_module' : ''
       ]"
  >
    <!--has_system_module 代表这个列下面，是否存在系统挂件-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="col_edit_frame"
        :class="column.data[$store.state.app.view_pattern + '_infor'].col <= 3 ? 'col_edit_top' : ''"
        v-if="isEdit"
      ></div>
    </template>

    <!--列宽度缩放(pc独有)-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div class="column_resize_handle" v-if="isEdit">
        <div class="column_resize_handle_icon"></div>
      </div>
      <div class="column_resize_border" v-if="isEdit"></div>
    </template>

    <span
      class="column_operation_line"
      v-show="column.children && column.children.length == 0 ? true : false"
    >
      <div class="hover_border_top"></div>
      <div class="hover_border_left"></div>
      <div class="hover_border_right"></div>
      <div class="hover_border_bottom"></div>
    </span>

    <!--添加模块(pc独有)-->
    <template v-if="$store.state.app.view_pattern === 'pc'&&!material_tag">
      <div
        class="column_no_child_frame"
        v-if="column.children && column.children.length == 0 ? true : false"
      >
        <div class="column_no_child">
          <div class="child_frame">
            <el-button plain type="primary" @click.stop="add_module">
              <i class="web_col_content_empty_tips_icon"></i>{{$t('widgets_layout_column_index_2931')}}</el-button>
            <p>{{$t('widgets_layout_column_index_2932')}}</p>
            <p>{{$t('widgets_layout_column_index_2933')}}</p>
          </div>
        </div>
      </div>
    </template>

    <template v-if="$store.state.app.edit_column && column.widgets_id == $store.state.app.edit_column.widgets_id">
      <div class="col_handler_line col_handler_line_top"></div>
      <div class="col_handler_line col_handler_line_right"></div>
      <div class="col_handler_line col_handler_line_bottom"></div>
      <div class="col_handler_line col_handler_line_left"></div>
    </template>

    <div
      class="modules_ sort_modules_"
      :data-id="column.widgets_id"
      :data-index="col_index"
      :rowType="column.rowType"
      :class="[
        row.data.is_system == 'true' ? 'system_col_sort_modules' : '',
        column.rowType === 'header' ? 'header_col' : '',
        column.rowType === 'body' ? 'body_col' : '',
        column.rowType === 'footer' ? 'footer_col' : '',
        column.rowType == 'header' && row_has_basic_loginregister ? 'header_row_col' : ''
       ]"
    >
      <template v-for="(val, i) in column.children">
        <div class="layrow layout_row_2">
          <layout_column
            v-for="(column_2, i) in val.children"
            :column="column_2"
            :row="val"
            :row1="row"
            :col_index="i"
            :material_tag="material_tag"
            :key="column_2.widgets_id"
            :col_order_val="col_order_val"
          ></layout_column>
        </div>
        <!--        <layout_row_2 :row="val" :row1="row" :row2="val" :row_index="i" :key="val.widgets_id"-->
        <!--                      v-show="$store.state.app.view_pattern == 'mb' ? val.data.mb_infor.isShow ? true : $store.state.mb_row_isShow.row_btn_isShow : true"></layout_row_2>-->
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import basic_module from '../basic_module/index'
import layout_row_2 from '../layout_row_2/index'
import layout_column from '../layout_column/index'
import {
  create_col_style
} from '@/base/col_style_data';

export default {
  name: 'layout_column_new',
  components: {
    basic_module, layout_row_2, layout_column
  },
  props: {
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    col_index: {
      type: Number,
      default: 0
    },
    material_tag: {
      type: Boolean,
      defaults: false
    },
    banner_id: {
      type: Number
    },
    col_order_val: {
      type:String,
      default: 'default'
    }
  },
  data() {
    return {}
  },
  computed: {
    has_system_module() {
      // 新版通栏里没有系统挂件，如果以后有了，这里要改

      return false

      let r = false
      for (let i = 0; i < this.column.children.length; i++) {
        const module = this.column.children[i]
        if (
          module.data.is_system === 'true' ||
          module.data.isSystem === 'true'
        ) {
          r = true
          break
        }
      }
      return r
    },
    infor() {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.column.data.pc_infor;
      } else {
        return this.column.data.mb_infor
      }
    },
    isEdit() {
      return this.templet.row_is_edit(this.row)
    },
    background_obj() {
      return this.data_judge(this.column.data.mb_infor.background_set.radio_val);
    },
    border_obj() {
      return this.data_judge(this.column.data.mb_infor.border_set.radio_val);
    },
    padding_obj() {
      return this.data_judge(this.column.data.mb_infor.padding_pattern);
    },
    margin_obj() {
      return this.data_judge(this.column.data.mb_infor.margin_pattern);
    },
    col_num() {
      return this.templet.calculation_col_num(this.column, this.row);
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    slideLength() {
      let num = this.$store.state.myRender.body.length
      let pageNum = this.$store.state.myRender.private.banner_isShow ? num + 1 : num
      return pageNum
    },
    columnStyle() {
      let style = {}
      if (this.column.newType === 'col1' || this.column.newType === 'col2') {
        // 新通栏
        return {}
      }
      let isEmptyRow = this.column.children.length === 0
      if (this.isFullPage && isEmptyRow && this.row.rowType === 'body') {
        let headerIsShow = String(this.$store.state.myRender.common.header_display) === 'true'
        let footerIsShow = String(this.$store.state.myRender.common.footer_display) === 'true'
        let headerIsXuanfu = this.$store.state.myRender.private.fullPageTopNavType === 'xuanfu'
        let headerIsFixed = String(this.$store.state.myRender.common.fixed_header) === 'true'
        let fullPageCurrentIndex = this.$store.state.app.fullPageCurrentIndex
        let isLastPage = this.$store.state.myRender.body[this.$store.state.myRender.body.length - 1].widgets_id === this.row.widgets_id //fullPageCurrentIndex === this.slideLength - 1
        let height = $(window).height() - $('.topBar').height()
        if ((headerIsShow && (headerIsFixed || fullPageCurrentIndex == 0))) {
          if (headerIsXuanfu) {
            style.top = ($('.myheader').height() + 1) + 'px'
          }
          height = height - $('.myheader').height()
        }
        if (footerIsShow && isLastPage) {
          height = height - $('.myFooter').height()
        }
        style.height = height + 'px'
      }
      return style

    },
    row_has_basic_loginregister() { // 通栏登录注册 头部组件
      return this.row.rowType === 'header' && this.templet.row_has_module(this.row, 'basic_loginregister');
    },
  },
  watch: {},
  methods: {
    add_module() {
      if (this.isEdit) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_layout_column_index_2934')
        })
      } else {
        this.$store.commit('left_sidebar/set_dialog', true)
        this.$store.commit('left_sidebar/set_active', 'module')
        this.$store.commit('app/set_addModule_col', this.column.widgets_id)
      }
    },
    edit_column() {
      this.$store.commit('app/SET_module_Data', this.column)
      this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
      this.$store.commit('main_dialog/Change_edit_name', this.column.name)
    },
    data_judge(mb_radio_val) {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.column.data.pc_infor
      } else {
        //如果是手机端
        //如果手机端上的列选择了默认，则返回pc数据
        if (mb_radio_val === 'default') {
          return this.column.data.pc_infor;
        } else {
          return this.column.data.mb_infor
        }
      }
    },
  },
  created() {
    //兼容处理
    if (typeof this.column.data.mb_infor.background_set == "undefined") {
      this.$set(this.column.data, 'mb_infor', {
        col: 1,
        order: 0,//用于自定义排序用
        ...create_col_style()
      })
    }
    if (typeof this.column.data.pc_infor.padding_pattern == "undefined") {
      this.$set(this.column.data.pc_infor, 'padding_pattern', 'default')
      this.$set(this.column.data.pc_infor, 'margin_pattern', 'default')
      this.$set(this.column.data.pc_infor, 'margin_top', '0%')
      this.$set(this.column.data.pc_infor, 'margin_bottom', '0%')
      this.$set(this.column.data.pc_infor, 'margin_left', '0%')
      this.$set(this.column.data.pc_infor, 'margin_right', '0%')
    }
  },
  mounted() {
    // this.templet.module_sortable(this.column.widgets_id)
    // this.$store.commit('app/set_role', 'designer'); // @todo  开发调试用，要删除
  }
}
</script>

<style lang="scss">
@import '~@/css/global-variable.scss';

.layout_column {
  .col_edit {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);

    .separator {
      width: 1px;
      height: 16px;
      background: #f5f5f5;
    }

    p {
      padding: 0 10px;
      cursor: pointer;

      &:hover {
        color: $theme-primary;
      }
    }

    .set {
      width: 30px;
      height: 30px;
      font-size: 0;

      &:nth-of-type(1) {
        margin-left: 10px;
      }

      i {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(~@/assets/image/cssSprite.png) no-repeat;
        cursor: pointer;
        /*background-color: red;*/
        &.left {
          background-position: -782px -111px;
        }

        &.right {
          background-position: -841px -111px;
        }

        &.close {
          background-position: -418px -111px;
        }

        &:hover {
          background-position-y: -66px;
        }

        &.disabled {
          background-position-y: -111px;
          opacity: 0.5;
        }
      }
    }
  }

  .column_resize_handle {
    z-index: 100;
    position: absolute;
    top: 10%;
    right: -4px;
    width: 9px;
    height: 80%;
    border-radius: 2px;
    background: #666;
    cursor: ew-resize;

    &:hover {
      background: #5874d8;
    }

    &::before {
      display: none;
      content: '调整列宽度';
      position: absolute;
      top: 50%;
      margin-top: -13px;
      left: 20px;
      width: 70px;
      padding: 2px 8px;
      border: 1px solid #f5e4b9;
      font-size: 13px;
      line-height: 21px;
      color: #333;
      background-color: #fffaee;
      border-radius: 2px;
    }

    &:hover::before {
      display: block;
    }

    .column_resize_handle_icon {
      position: absolute;
      top: 50%;
      margin-top: -2px;
      width: 9px;
      height: 5px;
      background: url(~@/assets/image/mbg01.png) -254px -46px no-repeat;
    }
  }

  .column_no_child_frame {
    .el-button {
      font-size: 15px;
      background-color: rgba(202, 214, 255, 0.1);
      cursor: pointer;

      span {
        display: flex;
        justify-content: center;
        align-items: center;

        .web_col_content_empty_tips_icon {
          display: inline-block;
          width: 17px;
          height: 14px;
          margin-right: 11px;
          background: url(~@/assets/image/cssSprite.png) no-repeat;
          background-position: -1302px -74px;
          vertical-align: middle;
        }
      }

      &:hover .web_col_content_empty_tips_icon {
        background-position: -1302px -120px;
      }
    }
  }

  .col_handler_line {
    position: absolute;
    z-index: 11;
  }

  .col_handler_line_top {
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    border-top: 3px dashed #5874d8;
  }

  .col_handler_line_right {
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    border-right: 3px dashed #5874d8;
  }

  .col_handler_line_bottom {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    border-bottom: 3px dashed #5874d8;
  }

  .col_handler_line_left {
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    border-left: 3px dashed #5874d8;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/layout_column_new/index.vue